import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppHttpService } from '../AppServices/app.httpservices';
import { EmailBody } from '../Models/EmailBody';
import { Project } from '../Models/Project';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public isSuccess = false;
  public isSubmitted = false;
  public isSubmitting = false;
  group: FormGroup;

  ProjectList = new Array<Project>();

  constructor(private elementRef: ElementRef, private fb: FormBuilder, private httpService: AppHttpService) { }

  ngOnInit() {
    this.httpService.get<Array<Project>>('api/Projects/Get', null).subscribe(data => {
      this.ProjectList = data;
    });

    this.group = this.fb.group({
      name: new FormControl('', Validators.required),
      message: new FormControl('', Validators.required),
      fromEmail: new FormControl('', Validators.required),
      fromPhone: new FormControl('', Validators.required)
    });
  }

  SubmitMessage() {

    const email = new EmailBody();
    email.Name = this.group.get('name').value;
    email.Message = this.group.get('message').value;
    email.FromEmail = this.group.get('fromEmail').value;
    email.FromPhone = this.group.get('fromPhone').value;
    if (email.Name.length > 0 && email.Message.length > 0 && email.FromEmail.length > 0 && email.FromPhone.length > 0) {
      this.isSubmitting = true;
      this.httpService.post<any>("api/Email/SendEmail", email).subscribe(data => {
        this.isSubmitted = true;
        this.isSuccess = data;
        this.group.get('name').setValue('');
        this.group.get('message').setValue('');
        this.group.get('fromEmail').setValue('');
        this.group.get('name').markAsUntouched();
        this.group.get('message').markAsUntouched();
        this.group.get('fromEmail').markAsUntouched();
        this.group.get('fromPhone').markAsUntouched();
        this.group.get('name').markAsPristine();
        this.group.get('message').markAsPristine();
        this.group.get('fromEmail').markAsPristine();
        this.group.get('fromPhone').markAsPristine();
   
        this.isSubmitting = false;

      }, error => {
        this.isSubmitted = true;
        this.isSuccess = false;
        this.isSubmitting = false;
      });
    }
  }

}
